module.exports = __webpack_public_path__ + "static/varbla-pk-logo-9ea370b2b309cd9dd07e60be3279727d.jpg";